import React from 'react';

import './HomeInsuranceCard.css';

const HomeInsuranceCard = ({ src, alt }) => {
  return (
    <div className='home-insurance-card-container'>
      <img src={src} alt={alt} />
    </div>
  );
};

export default HomeInsuranceCard;
